import { useEffect, useState } from 'react';
import { Controller, useForm } from 'react-hook-form';
import { useNavigate, useParams } from 'react-router-dom';

import { RULES } from 'constants/rules';

import { formatPhone } from 'utils/format';

import Button from 'components/Button';
import Navigator from 'components/Navigator';
import Typography from 'components/Typography';
import VerifyCode from 'components/VerifyCode/VerifyCode.tsx';

import { useSimulatorStore } from 'store/useSimulatorStore.ts';

import { OTP_PROVIDER, OTP_Title } from './OTP.constants.ts';
import {
  OTPButton,
  OTPContainer,
  OTPContent,
  OTPProvider,
  OTPStyled,
  ResetContainer,
  WrapperOTP,
} from './OTP.styled.ts';

type FormData = {
  code: string;
};

const OTP = () => {
  const { type } = useParams<{ type: 'telefono' | 'correo' }>();
  const navigate = useNavigate();

  const { form, savePhoneOTP, phone_otp, saveEmailOTP, email_otp } =
    useSimulatorStore();

  const [timer, setTimer] = useState(60);

  const {
    control,
    handleSubmit,
    formState: { isValid },
  } = useForm<FormData>({
    defaultValues: {
      code: '',
    },
    mode: 'onChange',
  });

  useEffect(() => {
    if (timer > 0) {
      setTimeout(() => {
        return setTimer(timer - 1);
      }, 1000);
    }
  }, [timer]);

  const onSubmit = (data: FormData) => {
    if (type === 'telefono') {
      savePhoneOTP({
        code: data.code,
        attempts: phone_otp ? phone_otp.attempts + 1 : 1,
        correct: true,
      });
      navigate('/datos-cliente/correo');
    } else if (type === 'correo') {
      saveEmailOTP({
        code: data.code,
        attempts: email_otp ? email_otp.attempts + 1 : 1,
        correct: true,
      });
      navigate('/cotizacion-prestamo');
    }
  };

  const handleResendCode = () => {
    if (timer === 0) {
      console.log('enviar codigo');
    }
  };

  const formatProvider = () => {
    if (type === 'telefono') {
      return formatPhone(String(form?.telefono));
    }

    if (type === 'correo') {
      return String(form?.correo);
    }

    return '';
  };

  return (
    <>
      <Navigator title="Cotizar préstamo" />
      <OTPContainer>
        <WrapperOTP>
          <OTPContent>
            <Typography type="Body" size="medium" color="#5C5C5C">
              {OTP_Title[type as keyof typeof OTP_Title]}
            </Typography>

            <OTPStyled>
              <OTPProvider>
                <Typography
                  type="Title"
                  size="small"
                  color="#0C0C0C"
                  style="semibold"
                >
                  {OTP_PROVIDER[type as keyof typeof OTP_PROVIDER]}
                </Typography>
                <Typography type="Title" size="small" color="#493F22">
                  {formatProvider()}
                </Typography>
              </OTPProvider>

              <Typography
                children="Ingrésalo aquí:"
                type="Title"
                size="small"
                style="semibold"
                color="rgba(12, 12, 12, 1)"
              />

              <Controller
                name="code"
                control={control}
                rules={RULES.otp}
                render={({ field: { onChange } }) => {
                  return (
                    <VerifyCode
                      theme="dark"
                      numberOfBoxes={4}
                      width="60dvw"
                      height="5dvh"
                      onChangeValue={onChange}
                    />
                  );
                }}
              />

              <ResetContainer>
                <Typography
                  children="Reenviar"
                  type="Body"
                  size="medium"
                  style="bold"
                  color="#493F22"
                  className="underline"
                  onClick={handleResendCode}
                />
                <Typography
                  children={`Código válido por: ${timer} s`}
                  type="Body"
                  size="medium"
                  style="bold"
                  color="#493F22"
                />
              </ResetContainer>
            </OTPStyled>
          </OTPContent>
        </WrapperOTP>

        <OTPButton>
          <Button
            variant="primary"
            onClick={handleSubmit(onSubmit)}
            disabled={!isValid}
          >
            Confirmar código
          </Button>
        </OTPButton>
      </OTPContainer>
    </>
  );
};

export default OTP;
